import axios from "axios";


var base_url = window.location.origin === 'https://blacktiewp.makeitreal.live' ? "https://staging.blacktieskis.com" : "https://booknow.blacktieskis.com";
var allowed_hosts = ["https://import.blacktieskis.com","https://test.blacktieskis.com", "http://black-tie.test", "http://127.0.0.1:8000","http://blacktie.devs", "http://blacktie.test", "https://dev.blacktieskis.com", "https://staging.blacktieskis.com", "https://booknow.blacktieskis.com"]
if(allowed_hosts.includes(window.location.origin)){
    base_url = window.location.origin;
}


axios.defaults.baseURL = base_url;

const accessToken = localStorage.getItem('getToken');
if(accessToken){
    axios.defaults.headers.common['Authorization'] = accessToken;
}

axios.interceptors.response.use(function (response) {
    return response
}, function (error) {
    if (error.response.status === 401) {
        this.$store.dispatch('logout');
    }
    return Promise.reject(error)
})


export default {
    getAllResorts(filter) {
        return axios.get('/front_api/get-all-resorts', {params: filter});
    },

    getResortData(resort_id){
        return axios.get('/front_api/get-resort-data/'+resort_id);
    },
    getResortDataSelect(resort_id,is_pickup,store_id){
        return axios.get('/front_api/get-resort-data/'+resort_id, {params: {
                'is_pickup': is_pickup ? 1 : 0,
                'store_id': store_id,
            }});
    },

    getResortDeliveryTimes(resort_id, delivery_date, is_pickup, portal_url_code, store_id){
        return axios.get('/front_api/get-delivery-times/'+resort_id, {params: {
                'delivery_date' : delivery_date,
                'is_pickup': is_pickup ? 1 : 0,
                'portal_url_code': portal_url_code,
                'store_id': store_id,
            }});
    },

    getPackages(resort_id, number_of_days, delivery_date) {
        return axios.get('/front_api/get-packages/'+resort_id, {
            params: {
                'number_of_days': number_of_days,
                'delivery_date': delivery_date
            }
        });
    },

    getPackageAddons(resort_id, package_resort_ids, number_of_days, delivery_date, delivery_time,portal_url_code,is_pickup,store_id){
        return axios.post('/front_api/get-package-addons/'+resort_id, {
            'package_resort_ids' : package_resort_ids,
            'number_of_days' : number_of_days,
            'delivery_date' : delivery_date,
            'delivery_time' : delivery_time,
            'portal_url_code' : portal_url_code,
            'is_pickup':is_pickup,
            'store_id':store_id,
        });
    },

    getClothing(resort_id, delivery_date) {
        return axios.get('/front_api/get-clothing/'+resort_id, {
            params: {
                'delivery_date' : delivery_date,
            }
        });
    },

    getCustomerRepeatRenters(data) {
        return axios.get('/front_api/get-repeat-renters',{params: data});
    },

    fetchPortalData(url_code){
        return axios.get('/front_api/fetch-portal/'+url_code);
    },

    chekPortalCookie(url_code){
        return axios.post('/front_api/check-portal-active/'+url_code)
    },

    applyCoupon(reservation) {
        return axios.post('/front_api/apply-coupon/'+reservation.resort_id, reservation);
    },

    applyGlobalCoupon(reservation) {
        return axios.post('/front_api/apply-global-coupon/'+reservation.resort_id, reservation);
    },

    updateOrCreateUncompletedReservation(url,resort_id, data){
        return axios.post('/front_api/save-uncompleted-reservation/'+resort_id, {
            'url': url,
            'data': data,
        });
    },

    getUncompletedReservation(uc_id){
        let url = '/front_api/get-uncompleted-reservation';
        if(uc_id){
            url += '?uc_id='+uc_id
        }
        return axios.get(url);
    },

    deleteUncompletedReservation(uc_id){
        return axios.post('/front_api/delete-uncompleted-reservation/'+uc_id);
    },

    saveReservation(data){
        return axios.post('/front_api/save-reservation/'+data.resort_id, data);
    },

    getUserAddress(){
        return axios.get('/front_api/get-user-address');
    },

    logout() {
        return axios.post('/front_api/auth/logout');
    },

    login(login_form){
        delete axios.defaults.headers.common["Authorization"]; // or which ever header you have to remove
        return axios.post('/front_api/auth/login', login_form);
    },

    loginByKey(loginKey){
        delete axios.defaults.headers.common["Authorization"]; // or which ever header you have to remove
        return axios.post('/front_api/auth/login-by-key', {
            'key': loginKey
        });
    },

    resetPassword(uid, token, reset_form){
        delete axios.defaults.headers.common["Authorization"]; // or which ever header you have to remove
        return axios.post('/front_api/auth/reset-password/'+uid+'/'+token, reset_form);
    },

    register(register_form){
        delete axios.defaults.headers.common["Authorization"]; // or which ever header you have to remove
        return axios.post('/front_api/auth/register', register_form)
    },

    forgetPassword(forget_form){
        return axios.post('/front_api/auth/forget-password', forget_form)
    }
}
